
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Vue from "vue";
import { mapGetters } from "vuex";
import { SITE_DIRECTION } from "@/store/modules/common/constants";
import { SiteDirections } from "@/store/modules/common/interfaces";
import {
  Assessment,
  CreateAssessment,
  CreateAssessmentQuestion
} from "@/interfaces/recruiter/candidates/create_assessment";
import CreateAssessmentHeader from "@/components/recruiter/assessments/ai-assessments/CreateAssessmentHeader.vue";
// import RevenueChart from "@/components/recruiter/assessments/ai-assessments/RevenueChart.vue";
import RecentAssessmentsTable from "@/components/recruiter/assessments/ai-assessments/RecentAssessmentsTable.vue";
import AssessmentViewModal from "@/components/recruiter/assessments/ai-assessments/AssessmentViewModal.vue";
import PaginationControls from "@/components/shared/PaginationControls.vue";

export default Vue.extend({
  name: "AiAssessments",
  components: {
    CreateAssessmentHeader,
    RecentAssessmentsTable,
    AssessmentViewModal,
    PaginationControls
  },
  data() {
    return {
      saving: false,
      deleting: false,
      isFormValid: true,
      currentPage: 1,
      itemsPerPage: 5,
      totalItems: 0,
      showDeleteModal: false,
      showViewModal: false,
      selectedAssessment: null as Assessment | null,
      assessment: {
        title: "",
        description: "",
        type: "custom" as const,
        duration: 30,
        passScore: 70,
        maxAttempts: 3,
        isActive: true,
        questions: [] as CreateAssessmentQuestion[]
      } as CreateAssessment,
      rules: {
        required: (v: string) =>
          !!v || this.$t("candidate.assessments.create.required-field"),
        positive: (v: number) =>
          v > 0 || this.$t("candidate.assessments.create.positive-number"),
        scoreRange: (v: number) =>
          (v >= 0 && v <= 100) ||
          this.$t("candidate.assessments.create.score-range")
      }
    };
  },
  computed: {
    ...mapGetters("common", {
      get_site_direction: SITE_DIRECTION
    }),
    SiteDirections() {
      return SiteDirections;
    },
    recentAssessments() {
      console.log(
        "recentAssessments",
        this.$store.getters["recruiter/FETCH_AI_ASSESSMENT_LISTING"]
      );
      const assessments =
        this.$store.getters["recruiter/FETCH_AI_ASSESSMENT_LISTING"] || [];
      return assessments;
    }
  },
  methods: {
    async createAssessment(): Promise<void> {
      this.saving = true;
      try {
        // Redirect to assessments list
        this.$router.push("/recruiter/ai-assessments/create");
      } catch (error) {
        console.error("Error creating assessment:", error);
        this.$store.commit("ROOT_ERROR", {
          message: this.$t("recruiter.assessments.create.save-error"),
          type: "error"
        });
      } finally {
        this.saving = false;
      }
    },
    viewAssessment(assessment: Assessment) {
      this.selectedAssessment = assessment;
      this.showViewModal = true;
    },
    editAssessment(assessment: Assessment) {
      this.$router.push(`/recruiter/ai-assessments/edit/${assessment.id}`);
    },
    async deleteAssessment(assessment: Assessment) {
      this.selectedAssessment = assessment;
      this.showDeleteModal = true;
    },
    async confirmDelete() {
      if (!this.selectedAssessment) return;

      try {
        this.deleting = true;
        const success = await this.$store.dispatch(
          "recruiter/DELETE_AI_ASSESSMENT",
          this.selectedAssessment.id
        );

        if (success) {
          this.$store.commit(
            "ROOT_NOTIFICATION",
            "Assessment deleted successfully"
          );
        } else {
          this.$store.commit(
            "ROOT_NOTIFICATION",
            "Assessment deleted successfully"
          );
        }
      } catch (error) {
        console.error("Error deleting assessment:", error);
        this.$store.commit(
          "ROOT_NOTIFICATION",
          "Assessment deleted successfully"
        );
      } finally {
        this.deleting = false;
        this.showDeleteModal = false;
        this.selectedAssessment = null;
      }
    },
    cancelDelete(): void {
      this.showDeleteModal = false;
      this.selectedAssessment = null;
    },
    async fetchRecentAssessments(): Promise<void> {
      const currentUser = this.$store.getters["auth/GET_USER_DETAILS"];
      if (currentUser && currentUser.id) {
        try {
          const result = await this.$store.dispatch(
            "recruiter/FETCH_AI_ASSESSMENT_LISTING",
            {
              user_id: currentUser.id,
              generated_from: "AI",
              page: this.currentPage,
              limit: this.itemsPerPage
            }
          );

          // The API returns { data: { assessments: [], total: number } }

          this.totalItems = result.total;
        } catch (error) {
          console.error("Error fetching assessments:", error);
        }
      }
    },
    onPageChange(page: number): void {
      this.currentPage = page;
      this.fetchRecentAssessments();
    },
    onItemsPerPageChange(limit: number): void {
      this.currentPage = 1; // Reset to first page when changing items per page
      this.itemsPerPage = limit;
      this.fetchRecentAssessments();
    }
  },
  async mounted() {
    await this.fetchRecentAssessments();
  }
});
